//libs
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
//apis
import { getProductDetailData } from 'shared/api/product-details';

//helpers
import { isOneSizeProduct } from 'shared/helpers/productHelpers';

//actions
import { updateProductSKUFromWishlistStore } from 'shared/store/wishlist/actions';

//selectors
import { product as _product } from 'shared/store/wishlist/selectors';

const getSizesData = (data: ProductDetail.IProduct) => ({
  sizes: { ...data.sizeOptions },
  sizeGuideUrl: data.sizeGuideURL,
  isOneSize: isOneSizeProduct({
    productType: data.type,
    sizeLength: get(data, 'sizeOptions.options', []).length,
  }),
});

export default function useFetchWishlistProducts(productId: string, shouldFetch = true) {
  const product = useSelector(_product(productId));
  const dispatch = useDispatch();
  const [isFetching, setIsFetching] = useState(false);
  const [isError, setIsError] = useState('');
  const [errorStatusCode, setErrorStatusCode] = useState('');

  const fetchProduct = useCallback(async () => {
    if (product?.sizeOptions) return;
    setIsFetching(true);
    setIsError('');
    const productDetails = getProductDetailData({
      productID: productId,
      isNew: true,
      headers: {},
      isMobile: true,
    });

    return productDetails
      .then((pdpDetails) => {
        setIsFetching(false);
        dispatch(
          updateProductSKUFromWishlistStore(productId, getSizesData(pdpDetails.response.product))
        );
      })
      .catch((e) => {
        setErrorStatusCode(e?.status);
        setIsFetching(false);
        setIsError(e);
        return Promise.reject(e);
      });
  }, [dispatch, product?.sizeOptions, productId]);
  useEffect(() => {
    if (shouldFetch) fetchProduct();
  }, [fetchProduct, product, shouldFetch]);

  return { fetchProduct, isFetching, product, productFetchError: isError, errorStatusCode };
}
